import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { ToastProvider } from './context/ToastContext';
import { ToastContainer } from "react-fox-toast"
import { AuthProvider } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import { Provider } from 'react-redux';
import store from './store';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<ToastProvider>
				<BrowserRouter>
					<AuthProvider>
						<DataProvider>
							<App />
						</DataProvider>
					</AuthProvider>
				</BrowserRouter>
			</ToastProvider>
			<ToastContainer 
				gap = {10}
				position='top-center'
				isPausedOnHover={true} // Add this to pause the toast on hover (optional)
			/> 
		</Provider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
